import type { FC } from 'react';

import type { LeadGenPageProps, PageProps } from '@/types';

import {
  EarnIncremental,
  LeadGenHero,
  HowToProceed,
  PoweredBy,
  SendingMoney,
  UnifiedSolution,
} from '../lead-gen';
import Head from 'next/head';

export const LeadGen: FC<PageProps<LeadGenPageProps>> = ({ data, meta }) => {
  const {
    title,
    heroImage,
    sendingMoneyTitle,
    sendingMoneySubtitle,
    sendingMoneyCards,
    unifiedSolutionTitle,
    unifiedSolutionSubtitle,
    unifiedSolutionCards,
    unifiedSolutionFooter,
    earnIncrementalTitle,
    earnIncrementalValues,
    earnIncrementalCards,
    poweredBySection,
    poweredByCta,
    howToProceedTitle,
    howToProceedCards,
  } = data;

  return (
    <div>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>

      <LeadGenHero
        title={title}
        images={heroImage}
        translation={meta.translation.leadGen}
      />
      <SendingMoney
        title={sendingMoneyTitle}
        subtitle={sendingMoneySubtitle}
        cards={sendingMoneyCards}
      />
      <UnifiedSolution
        title={unifiedSolutionTitle}
        subtitle={unifiedSolutionSubtitle}
        cards={unifiedSolutionCards}
        footer={unifiedSolutionFooter}
      />
      <EarnIncremental
        title={earnIncrementalTitle}
        values={earnIncrementalValues}
        cards={earnIncrementalCards}
      />
      <PoweredBy section={poweredBySection} cta={poweredByCta} />
      <HowToProceed
        title={howToProceedTitle}
        cards={howToProceedCards}
        translation={meta.translation.leadGen}
      />
    </div>
  );
};
